import { ApiProperty } from "@nestjs/swagger";

export class EmployeeDesignationRequest{
    @ApiProperty()
    employeeId:number;
    @ApiProperty()
    designation:string;
    
   
}